import { httpClient } from "../http"

export interface PlaylistType {
  id: number
  title: string
  description: string
  isPublic: boolean
  code: string
  authorId: number
}

export enum PlaylistQueryType {
  PLAYLIST,
  ME,
  FEATURED,
}

export interface PlaylistQuery {
  constraint?: PlaylistQueryType
  code?: string
}

export class PagedPlaylistResponse {
  playlists: PlaylistType[] = []
  nResults = 0
}

export const getPlaylists = async (
  query: PlaylistQuery
): Promise<PagedPlaylistResponse> => {
  let param = "playlists"

  switch (query.constraint) {
    case PlaylistQueryType.PLAYLIST:
      if (!query.code || !query.code.length || query.code === "-1")
        return new PagedPlaylistResponse()
      param += `/${query.code}`
      break

    case PlaylistQueryType.ME:
      param += "/me"
      break

    case PlaylistQueryType.FEATURED:
      param += "/public"
      break

    default:
      throw new Error("Invalid PlaylistQuery constraint")
  }

  return httpClient.instance.get<PagedPlaylistResponse>(param)
}
